import { useTheme } from '@mui/system'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import { Field, Form, Formik } from 'formik'
import AdxFormControlLabel from 'components/custom/AdxFormControlLabel'
import AdxRadioButton from 'components/custom/AdxRadioButton'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'
import * as Yup from 'yup'
import {
  createDraftValidation,
  DEFAULT_CREATE_DRAFT,
} from 'module/recruitment/utils/jobAdValidation'
import { Box, Icon, RadioGroup, Typography } from '@mui/material'
import AdxInput from 'components/custom/AdxInput'

const CreateJobAdModal = ({ open, onClose, handleClose, mutate, isLoading, onSubmit }) => {
  const theme = useTheme()
  const horizontalButtonStyle = {
    display: 'flex',
    justifyContent: 'center',
    flexGrow: 1,
    borderRadius: 0,
    height: theme.componentHeight.standard,
    width: '100%',
  }
  return (
    <Formik
      enableReinitialize={true}
      validateOnBlur={false}
      initialValues={DEFAULT_CREATE_DRAFT}
      validationSchema={Yup.object().shape(createDraftValidation)}
      onSubmit={onSubmit}
    >
      {({ values, touched, errors, handleChange, handleSubmit, setFieldValue }) => {
        return (
          <AdxFormModal
            open={open}
            onClose={onClose}
            sxModal={{ width: 700 }}
            title="Create job advertisement"
            subtitle={null}
            enableFooter={true}
            cancelText="Cancel"
            handleClose={() => handleClose()}
            actionText="Create"
            handleAction={() => handleSubmit()}
            icon={<Icon>create</Icon>}
          >
            <Box
              sx={{
                width: '100%',
              }}
            >
              <Form>
                {/* position title */}
                <Field
                  as={AdxInput}
                  name="position_title"
                  label={
                    <Box display="flex">
                      <Typography variant="body1" color="dark-text.main">
                        Position Title
                      </Typography>
                      <Typography variant="body1" color="error.main">
                        *
                      </Typography>
                    </Box>
                  }
                  placeholder="e.g. Software Engineer"
                  isErrorShown={touched.position_title && Boolean(errors.position_title)}
                  errorMessage={<AdxErrorMessage>{errors.position_title}</AdxErrorMessage>}
                  value={values.position_title}
                  required
                />
                {/* Employment Type */}
                <Box mt={2}>
                  <Box display="flex">
                    <Typography variant="body1" mb={1}>
                      Employment Type
                    </Typography>
                    <Typography variant="body1" mb={1} color="error.main">
                      *
                    </Typography>
                  </Box>
                  <Field as={RadioGroup} name="position_type" value={values.position_type}>
                    <Box
                      border={touched.position_type && Boolean(errors.position_type) ? 1 : 0}
                      borderRadius="5px"
                      borderColor="red"
                      display="flex"
                    >
                      <AdxFormControlLabel
                        type="outlined"
                        control={<AdxRadioButton type="no-radio" />}
                        label="Full time"
                        value="full-time"
                        selected={values.position_type}
                        sx={{ ...horizontalButtonStyle, borderRadius: '5px 0 0 5px' }}
                      />
                      <AdxFormControlLabel
                        type="outlined"
                        control={<AdxRadioButton type="no-radio" />}
                        label="Contract"
                        value="contract"
                        selected={values.position_type}
                        sx={horizontalButtonStyle}
                      />
                      <AdxFormControlLabel
                        type="outlined"
                        control={<AdxRadioButton type="no-radio" />}
                        label="Part time"
                        value="part-time"
                        selected={values.position_type}
                        sx={{ ...horizontalButtonStyle, borderRadius: '0 5px 5px 0' }}
                      />
                    </Box>
                    {errors.position_type ? (
                      <AdxErrorMessage>{errors.position_type}</AdxErrorMessage>
                    ) : null}
                  </Field>
                </Box>
              </Form>
            </Box>
          </AdxFormModal>
        )
      }}
    </Formik>
  )
}
export default CreateJobAdModal
